// extracted by mini-css-extract-plugin
export default {"main":"IndustryFilter_main__ajoql","list":"IndustryFilter_list__jRvzf","card":"IndustryFilter_card__WMAzr"};